import fetch from "auth/FetchMasterInterceptor";

const OrderService = {};

OrderService.getOrders = function (params) {
  return fetch({
    url: "/order/list",
    method: "post",
    data: params,
  });
};

OrderService.storeOrder = function (data) {
  return fetch({
    url: "/order/create",
    method: "post",
    data: data,
  });
};

OrderService.updateOrderStatus = function (data) {
  return fetch({
    url: "/order/status",
    method: "post",
    data: data,
  });
};

OrderService.updateOrderProductStatus = function ({ order_id, order_product_id, status }) {
  return fetch({
    url: `/orders/${order_id}/products/${order_product_id}/status`,
    method: "patch",
    data: { status },
  });
};

OrderService.updateProductStatus = function (data) {
  return fetch({
    url: "/order/product/status",
    method: "post",
    data: data,
  });
};

OrderService.deleteDispatchProduct = function (data) {
  return fetch({
    url: "/order/product/dispatch/delete",
    method: "post",
    data: data,
  });
};

OrderService.updateOrder = function (data) {
  return fetch({
    url: "/order/update",
    method: "post",
    data: data,
  });
};

OrderService.deleteOrder = function (data) {
  return fetch({
    url: "/order/delete",
    method: "post",
    data: data,
  });
};

OrderService.deleteProductOrder = function (data) {
  return fetch({
    url: "/order/product/delete",
    method: "post",
    data: data,
  });
};

OrderService.viewOrder = function (data) {
  return fetch({
    url: "/order/view",
    method: "post",
    data: data,
  });
};

OrderService.getOrderStatusOptions = function () {
  return fetch({
    url: "/order/status-options",
    method: "post",
    data: {},
  });
};

OrderService.getSaleStage = function (params) {
  return fetch({
    url: "/salestage/list",
    method: "post",
    data: params,
  });
};

OrderService.storeSaleStage = function (data) {
  return fetch({
    url: "/salestage/create",
    method: "post",
    data: data,
  });
};

OrderService.updateSaleStage = function (data) {
  return fetch({
    url: "/salestage/update",
    method: "post",
    data: data,
  });
};

OrderService.deleteSaleStage = function (data) {
  return fetch({
    url: "/salestage/delete",
    method: "post",
    data: data,
  });
};

OrderService.getCategory = function (data) {
  return fetch({
    url: "/order/category",
    method: "post",
    data: data,
  });
};

OrderService.getStock = function (data) {
  return fetch({
    url: "/stock/list",
    method: "post",
    data: data,
  });
};

OrderService.addStock = function (data) {
  return fetch({
    url: "/stock/add",
    method: "post",
    data: data,
  });
};

OrderService.updateStock = function (data) {
  return fetch({
    url: "/stock/update",
    method: "post",
    data: data,
  });
};

export default OrderService;
